var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brochure-request" },
    [
      _vm.loading
        ? _c("Loading")
        : [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isForm,
                    expression: "!isForm",
                  },
                ],
                staticClass: "brochure-select",
              },
              [
                _c("section", { staticClass: "section full-width" }, [
                  _c("div", { staticClass: "container-fluid" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", {
                        staticClass: "brochure-introduction",
                        domProps: {
                          innerHTML: _vm._s(
                            this.$store.state.brochureRequest.data
                              .introductionHtml
                          ),
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "section full-width" }, [
                  _c("div", { staticClass: "container-fluid" }, [
                    _c(
                      "ul",
                      { staticClass: "brochure-list" },
                      _vm._l(_vm.brochures, function (brochure) {
                        return _c(
                          "li",
                          {
                            key: brochure.uniqueId,
                            staticClass: "brochure-list__item",
                          },
                          [
                            _c("Brochure", {
                              attrs: { brochure: brochure },
                              on: { brochureSelected: _vm.brochureSelected },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "white-popup mfp-hide",
                      attrs: { id: "popup" },
                    },
                    [
                      _c("form", {
                        attrs: {
                          id:
                            "mktoForm_" +
                            (_vm.data.brand === "Travelsphere"
                              ? "2410"
                              : "2405"),
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("BrochureConfirmBar", {
                  attrs: { brandName: _vm.data.brand },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isForm,
                    expression: "isForm",
                  },
                ],
                staticClass: "brochure-selected-details",
              },
              [
                _c("section", { staticClass: "section full-width" }, [
                  _c("div", { staticClass: "container-fluid" }, [
                    _c(
                      "div",
                      { staticClass: "brochure-selected-details-row" },
                      [
                        _c(
                          "div",
                          { staticClass: "brochure-form-col" },
                          [_c("BrochureForm")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "brochure-selection-col" },
                          [
                            _c("BrochureSelection", {
                              attrs: { brandName: _vm.data.brand },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }